export default __webpack_public_path__ + "static/our-mission-cover-077da7463b821513107345e9767f94a1.jpg";